<apg-cover-calculator (continue)="onCoverCalculated($event.detail)" (back)="backToQuickQuote()">
</apg-cover-calculator>
